export class SetDay {
    public static readonly type = '[JobsPlacements] Set shift day';

    constructor(public day: Date) { }
}
